import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

@Component({
  selector: 'app-table-cell-status-renderer',
  templateUrl: './table-cell-status-renderer.component.html',
  styleUrls: ['./table-cell-status-renderer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCellStatusRendererComponent implements ICellRendererAngularComp {
  agInit(params: ICellRendererParams<any, any>): void {}

  refresh(params: ICellRendererParams<any, any>): boolean {
    return true;
  }
}
